import React from 'react';
import Benefits from '@portal/assets/svg/loan-icons/ic_benefits.svg?react';
import { translate } from '@portal/services/i18n';

const LoanAdvantages = () => {
  return (
    <div className="loan-advantages">
      <h1 className="loan-advantages__title">
        {translate('PAGES.LOAN.SIMULATE.LOAN_ADVANTAGES.USE')}
      </h1>
      <div className="loan-advantages__container">
        <div className="loan-advantages__select">
          <div className="loan-advantages__select__icon">
            <Benefits />
          </div>
          <div className="loan-advantages__select__benefits">
            <p className="loan-advantages__name">
              {translate('PAGES.LOAN.SIMULATE.LOAN_ADVANTAGES.ANALYSIS')}
            </p>
          </div>
        </div>
        <div className="loan-advantages__select">
          <div className="loan-advantages__select__icon">
            <Benefits />
          </div>
          <div className="loan-advantages__select__benefits">
            <p className="loan-advantages__name">
              {translate('PAGES.LOAN.SIMULATE.LOAN_ADVANTAGES.START')}
            </p>
          </div>
        </div>
        <div className="loan-advantages__select">
          <div className="loan-advantages__select__icon">
            <Benefits />
          </div>
          <div className="loan-advantages__select__benefits">
            <p className="loan-advantages__name">
              {translate('PAGES.LOAN.SIMULATE.LOAN_ADVANTAGES.DIGITAL')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanAdvantages;
